import type { FaireProductEntity } from "../../entity_types/product";

export const p_9gd4c869sb: FaireProductEntity = {
  token: "p_9gd4c869sb",
  type: "product",
  name: "Boxing Gloves Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/174c8f6c2019a58f058aacd8806987eb48003f6f863fc38d28336f0f55fd7fb7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4de3806b4428dd7e559a5fc33c305e3381e9c4f23312e4ac1307149b51d2b27.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:15.398Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
